import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { View ,Image,TouchableOpacity
} from "react-native";
import CInput from "../../common/CInput";
import CustomButton from "../../common/CustomButton";
import OtpModal from "../../common/OtpModal";
import CHeader from "../../common/CHeader";
import { CreateResponsiveStyle, DEVICE_SIZES, } from "rn-responsive-styles";
import { sendOtpApi,getUserDetails } from "../../api/apiManager";
import Loader from "../../common/Loader";
import { get } from "lodash";
import ModalAlert from "../../common/ModalAlert";
import CDocxViewer from "../../common/CDocxViewer";

export default function BasicDetails(props) {
    const styles = useStyles();
    const [otpModalVisible, setOtpModalVisible] = useState(false)
    const [isTermsChecked, setIsTermsChecked] = useState(true)
    const[tncModal,setTncModal] = useState(false)
    const [mobileNo, setMobileNo] = useState('')
    const [isMobileValid, setMobileValid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [otpData, setOtpData] = useState(false)
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        navigate: '',
        actionButton: "",
    });

    const getOtp = () => {
        setLoading(true)
        sendOtpApi({ mobileNo: mobileNo, "type": "usedCarLoan" }).then(res => {
            setLoading(false)
            if (res.statusCode == -1017 || res.statusCode == 500 || res.statusCode < 0) {
                setAlertModalVisible(true);
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
            } else {
                setOtpData(res)
                setOtpModalVisible(true)
                props.setBasicData({mobileNo :mobileNo})
                props.setOtpData({requestId :res?.response?.otp})

            }
            
        }).catch(err=>{setLoading(false)})
    }
  
    useEffect(() => {
      getProfileDetails()
    }, []);

    const getProfileDetails = () => {
        setLoading(true);
        getUserDetails()
          .then((res) => {
            if(get(res, "mobileNo", "")){
                setMobileNo((get(res, "mobileNo", "")));
                setMobileValid(true)
            }
            setLoading(false);  
          })
          .catch((err) => {
            setLoading(false);
            console.log("<------------ error in profile data api ----------->");
          });
      };

    return (
      <>
        <View>
          <CHeader
            onPress={props.setActiveScreen}
            title='Step 1 of 5'
            navigation='CarLoanIndex'></CHeader>
        </View>

        <View style={styles.contentWrapper}>
          <View>
            <CText.basicInformation>Basic Details</CText.basicInformation>
          </View>

          <View style={styles.col1}>
            <View>
              <CText.basicInformationSubHeader>Personal Details</CText.basicInformationSubHeader>
              <View style={{ marginTop: 22 }}>
                <CText.headerDesc>{`Please enter your mobile number (Preferably \nlinked with Aadhar & PAN)`}</CText.headerDesc>
              </View>
            </View>
            <View style={styles.inputWrapper}>
              <CInput
                label='Mobile number'
                inputWithTopLabel={true}
                value={mobileNo}
                onChangeText={setMobileNo}
                inputType='numeric'
                pattern='[6-9]{1}[0-9]{9}'
                onValidation={(isValid) => setMobileValid(isValid)}
                maxLength={10}
                mandatoryField={true}
                keyboardType={'phone-pad'}
              />
            </View>
          </View>

          <View style={{ marginTop: 70, flexDirection: 'row' }}>
            <TouchableOpacity
              onPress={() => {
                setIsTermsChecked(!isTermsChecked);
              }}
              style={[styles.radiobuttonOutSideStyle, { width: 15.9, height: 15.9, borderRadius: 3, borderColor: '#c3c3c3' }]}>
              {isTermsChecked ? (
                <View style={{ backgroundColor: '#666666', width: 15.9, height: 15.9, borderRadius: 3, borderColor: '#c3c3c3', alignItems: 'center' }}>
                  <Image
                    source={require('../../assets/images/termsChecked.png')}
                    style={{ width: 12, height: 12 }}
                  />
                </View>
              ) : null}
            </TouchableOpacity>
            <View style={{ paddingLeft: 10, width: '90%' }}>
              <CText.headerDesc>
                By clicking on Proceed I agree that I have read and I accept the
                <TouchableOpacity
                  onPress={() => {
                    setTncModal(true);
                  }}>
                  <CText.headerDesc style={{ textDecorationLine: 'underline', opacity: 1 }}> Terms and Conditions </CText.headerDesc>
                </TouchableOpacity>
                for Used Car Loan
              </CText.headerDesc>
            </View>
          </View>

          <View style={styles.footer}>
            <CustomButton
              text='Proceed'
              onPress={isMobileValid && isTermsChecked ? getOtp : () => {}}
              disable={!isMobileValid || !isTermsChecked}
            />
          </View>
        </View>
        {otpModalVisible && (
          <OtpModal
            data={otpData}
            type='usedCarLoan'
            onSuccess={props.setActiveScreen}
            navigation='CustInformation'
            getOtp={getOtp}
          />
        )}
        {loading ? <Loader /> : ''}
        {alertModalVisible && (
          <View style={styles.overlayViewStyle}>
            <ModalAlert
              title={alertModal.title}
              status={alertModal.status}
              message={alertModal.message}
              navigateScreen={alertModal.navigateScreen}
              actionButton={'OK'}
              onCloseModal={() => setAlertModalVisible(false)}
            />
          </View>
        )}
         {tncModal && (
          <CDocxViewer type = "FF_UCL_TNC" visibility ={setTncModal} />)}
      </>
    );
}

const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        display: "flex",
        marginLeft: 50,
        paddingLeft: 40,
        paddingTop: 10
    },
    radiobuttonOutSideStyle: {
        width: 15,
        height: 15,
        borderRadius: 10,
        borderColor: "#9d1d27",
        borderWidth: 2,
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 10,
      },
      overlayContentStyle: {
        width: "60%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: 15,
        
      },
      pdfViewStyle: {
        height: "60%",
        width: "100%",
      },
    col1: {
        flexDirection: "row",
        marginTop: 60,

    },
    footer: {
        flexDirection: "row",
        alignSelf: "flex-end",
        width: 220,
        height: 44,
        marginTop: 50,
        marginRight: 32
    },
    inputWrapper: {
        marginLeft: "20%"
    },

    overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
        alignItems:"center"
    },


},
    {
        [DEVICE_SIZES.LG]: {


        },
        [DEVICE_SIZES.MD]: {

        },
        [DEVICE_SIZES.SM]: {

        },
        [DEVICE_SIZES.XS]: {
            col1: {
                flexDirection: "column",
            },
            inputWrapper: {
                marginLeft: 0,
                marginTop: 63
            },
            contentWrapper: {
                paddingLeft: 0
            },
            footer: {
                alignSelf: "center",
            },
            overlayContentStyle: {
                width: "90%",
              },
              pdfViewStyle: {
                alignItems: null,
              },

        }
    }

)